import { render } from "./FormNotes.vue?vue&type=template&id=ea1495be"
import script from "./FormNotes.vue?vue&type=script&lang=js"
export * from "./FormNotes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__